export const nuvemshop = {
  typeAnimationFeatures: [
    { title: "24/7 Support" },
    { title: "Intelligent Automation" },
    { title: "Visual Marketing" },
    { title: "WhatsApp Business" },
  ],
  hero: {
    title: "Revolutionize Your E-commerce with Artificial Intelligence",
    subtitle:
      "Araria's AI Hub brings the power of artificial intelligence to your Nuvem Shop store, with intelligent customer service agents, automation, and advanced marketing tools.",
    cta: {
      primary: "Install Now",
      secondary: "See How It Works",
    },
  },
  mainFeatures: {
    title: "Transform Your E-commerce Operation",
    subtitle: "Boost your sales with advanced AI features",
  },
  features: {
    support24: {
      title: "24/7 Automated Support",
      description:
        "Offer instant support to your customers with personalized AI agents that work on your website and via WhatsApp, even when you're not available.",
    },
    automation: {
      title: "Intelligent Automation",
      description:
        "Reduce manual work hours with the Ária virtual assistant, who accesses data, creates products, and manages promotions directly from the panel.",
    },
    marketing: {
      title: "Powerful Visual Marketing",
      description:
        "Create professional promotional videos in minutes with our AI video generation tool, no specialized team needed.",
    },
    integration: {
      title: "Perfect Integration",
      description:
        "All Araria's AI tools integrate natively with your Nuvem Shop store, with no need for complex technical configurations.",
    },
  },
  agents: {
    title: "AI Agents: Intelligent Support for Your Store",
    subtitle:
      "Transform your store's customer service with personalized AI agents that know your products, policies, and answer questions 24 hours a day, 7 days a week.",
  },
  agent: {
    features: {
      knowledge: {
        title: "Custom Knowledge Base",
        description:
          "Feed your agent with specific information about your products, exchange policies, delivery times, and FAQs",
      },
      channels: {
        title: "Multiple Service Channels",
        description:
          "Make the same agent available on your website and via WhatsApp",
      },
      personality: {
        title: "Adjustable Personality",
        description:
          "Configure your agent's communication tone to reflect your brand identity",
      },
      analytics: {
        title: "Performance Analysis",
        description: "Track customer service and satisfaction metrics",
      },
    },
  },
  whatsapp: {
    title: "WhatsApp Support with Artificial Intelligence",
    subtitle:
      "Take your service where your customers are. Araria agents work perfectly on WhatsApp, allowing you to automate both promotional campaigns and customer support.",
    features: {
      instant: {
        title: "Instant Support",
        description: "Immediate responses 24/7 on consumers' preferred channel",
      },
      recovery: {
        title: "Cart Recovery",
        description: "Remind customers about abandoned cart products",
      },
      campaigns: {
        title: "Promotional Campaigns",
        description: "Send personalized offers to segmented customers",
      },
      tracking: {
        title: "Order Tracking",
        description: "Automatically update customers on delivery status",
      },
    },
  },
  aria: {
    title: "Meet Ária: Your Specialized E-commerce Virtual Assistant",
    subtitle:
      "Ária is not a simple chatbot. She's an intelligent assistant specifically developed for e-commerce management, integrated into your Nuvem Shop store's administrative environment.",
    features: {
      products: {
        title: "Product Management",
        description: "Create and update products with intelligent assistance",
      },
      promotions: {
        title: "Promotion Management",
        description: "Manage promotions and discount coupons easily",
      },
      tools: {
        title: "Advanced Tools",
        description: "Access store optimization and analysis tools",
      },
    },
  },
  videoCreator: {
    title: "Transform Photos into Professional Videos in Minutes",
    subtitle:
      "Our AI video creation tool transforms your catalog photos into professional advertising content for your social media and marketing campaigns.",
    features: {
      creation: {
        title: "Automatic Creation",
        description: "Transform photos into professional videos automatically",
      },
      customization: {
        title: "Total Customization",
        description: "Add your brand, music, and visual elements",
      },
      sharing: {
        title: "Easy Sharing",
        description: "Publish directly to social networks",
      },
    },
  },
  cta: {
    title: "Start Transforming Your E-commerce Today",
    subtitle:
      "Install Araria's AI Hub and take your Nuvem Shop store to the next level",
    button: "Install for Free",
  },
};
